
	import Leek from '@/component/leek/leek.vue'
	import { loadInstanceTranslations, i18n } from '@/model/i18n'
	const messages = {
	"ai": "AI",
	"ai_of": "AI equipped on {0}",
	"all_my_ais": "All my AIs",
	"all_my_chips": "All my chips",
	"all_my_weapons": "All my weapons",
	"authorize_agressions": "Allow attacks by other leeks",
	"br_time": "Automatic Battle Royale every two hours between 9:15 AM and 11:15 PM (French timezone)",
	"buy_hint": "You have {hab}, you can get more equipment in the {market}.",
	"challenge": "Challenge",
	"chips_of": "Chips equipped on {0}",
	"clear": "Clear",
	"click_to_change_hat": "Click to change hat",
	"click_to_put_hat": "Click to wear hat",
	"click_to_use": "Click to use",
	"copy_as_test": "Copy {0} as test leek",
	"customize": "Customize leek",
	"defeats": "losses",
	"draws": "draws",
	"edit": "Edit",
	"equip_item": "Click or drag and drop to equip or un-equip an item",
	"error_already_have_4_leeks": "You already have 4 leeks!",
	"error_forbidden_name": "This leek name is forbidden.",
	"error_name_already_used": "This leek name is already taken",
	"error_name_length": "Your leek name must contain between %d and %d characters",
	"error_name_format": "Your leek name must contain only alphanumeric characters",
	"error_under_required_level_1": "Your first leek must be level {0}.",
	"error_under_required_level_2": "Your second leek must be level {0}.",
	"error_under_required_level_3": "Your third leek must be level {0}.",
	"error_under_required_level_weapon": "{0} doesn't have the required level for this weapon.",
	"error_under_required_level_chip": "{0} doesn't have the required level for this chip.",
	"error_max_weapon": "{0} can't equip an additional weapon.",
	"error_max_chip": "{0} can't equip an additional chip.",
	"error_weapon_already_equipped": "{0} has already equipped this weapon.",
	"error_weapon_two_forgotten": "{0} cannot equip two forgotten weapons.",
	"error_chip_already_equipped": "{0} has already equipped this chip.",
	"farmed_by": "Raised by {farmer}",
	"fights": "Fights",
	"garden": "Garden",
	"garden_no": "NO",
	"garden_yes": "YES",
	"hide_registers": "Hide registers",
	"history": "History",
	"max_level": "Maximum level",
	"no_hat": "No hat",
	"no_ai": "No AI",
	"no_chips": "No chips",
	"no_weapon": "No weapon",
	"no_weapons": "No weapons",
	"not_found": "Leek not found",
	"not_found_id": "Leek with id {0} not found",
	"ok": "OK",
	"potions": "Potions",
	"ratio": "Ratio: {0}",
	"registered": "Registered",
	"register_key": "Key",
	"registers": "Registers",
	"register_to_tournament": "Register for tournaments",
	"register_to_br": "Register to auto BR",
	"register_value": "Value",
	"register_deleted": "Register deleted",
	"register_saved": "Register saved",
	"remaining_xp": "Remaining XP: {0}",
	"rename_description": "This operation allows you to rename your leek, you can pay with Habs or with crytals. It is possible to do this once a day.",
	"rename_done": "Leek renamed!",
	"rename_error_delay": "You must wait one day between two renamings of your leek",
	"rename_leek": "Rename leek",
	"rename_new_name": "New name",
	"rename_not_enough_crystals": "You don't have enough crystals.",
	"rename_not_enough_habs": "You don't have enough Habs.",
	"rename_pay_crystals": "Pay with crystals",
	"rename_pay_habs": "Pay with Habs",
	"report": "Report",
	"reset": "Reset",
	"see_tournament": "See the tournament",
	"select_a_hat": "Select a hat",
	"select_a_weapon": "Select a weapon",
	"select_skin": "Select a skin",
	"show_registers": "Show registers",
	"skin": "Skin",
	"statistics": "Statistics",
	"talent": "Leek solo Talent",
	"test": "Test",
	"title": "Title",
	"tournament": "Tournament",
	"tournament_time": "Solo tournament every day between 12:00 PM and 2:00 PM (French timezone)",
	"unregister": "Unregister",
	"use_a_potion": "Use a potion on {0}",
	"using_potion": "Using the potion...",
	"validate": "Validate",
	"victories": "wins",
	"weapon": "Weapon",
	"weapons": "Weapons",
	"weapons_of": "Weapons of {0}",
	"xp": "XP: {0}",
	"angry": "Angry",
	"happy": "Smiling",
	"neutral": "Neutral",
	"download_leek_image": "Download HD Image",
	"xp_blocked_desc": "If the option is activated, fights will no longer yield experience, and the leek will not level up. Talent and resource gains are retained.",
	"start_a_fight": "Start a fight!",
	"all_my_components": "My components",
	"error_max_component": "{0} cannot equip an additional component.",
	"ai_and_components": "AI and components"
}

	Leek.options.i18n = { messages: {en: messages }}
	export default Leek